import React, { useEffect, useState } from "react";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

// Formata um intervalo em ms de forma compacta para a lista: "23h", "1h 30min", "12min".
const fmtRemaining = (ms) => {
  if (ms <= 0) return "0min";
  const totalMin = Math.floor(ms / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h > 0) return m > 0 ? `${h}h ${m.toString().padStart(2, "0")}min` : `${h}h`;
  if (m > 0) return `${m}min`;
  return "<1min";
};

const WINDOW_MS = 24 * 3600000; // janela de 24h da WABA
const ALERT_MS = 3 * 3600000; // limiar de alerta (amarelo) padrão

/**
 * Chip compacto da janela de atendimento de 24h (WhatsApp Business API) para a
 * LISTA de tickets (coluna esquerda). Versão "pura": calcula direto de
 * `ticket.lastClientMessageAt` (já entregue pela listagem), sem chamada extra
 * à API. Só aparece em conexão oficial (waba); em wwebjs não há janela.
 * O indicador completo (com atalho de envio de template) continua no header
 * do ticket aberto — ver WabaWindowIndicator.
 */
const WabaWindowChip = ({ ticket }) => {
  const [now, setNow] = useState(Date.now());

  // Atualiza o relógio a cada 60s para o countdown "andar" e virar de cor.
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(i);
  }, []);

  // Só conexão WABA OFICIAL tem janela de 24h. NÃO basta type==='waba' — Baileys
  // rotulado waba (ex.: chip pessoal) também é 'waba' e não tem janela.
  if (!ticket || !ticket?.whatsapp?.isOfficialWaba) return null;
  const last = ticket.lastClientMessageAt;
  if (!last) return null; // cliente ainda não escreveu: não polui a lista

  const remaining = new Date(last).getTime() + WINDOW_MS - now;

  let color;
  let label;
  let tip;
  if (remaining <= 0) {
    color = "error";
    label = "Fechada";
    tip = "Janela de 24h fechada — para falar agora, envie um template aprovado (a resposta do cliente reabre a janela).";
  } else if (remaining <= ALERT_MS) {
    color = "warning";
    label = fmtRemaining(remaining);
    tip = `A janela de 24h fecha em ${fmtRemaining(remaining)} — responda agora; depois, só com template.`;
  } else {
    color = "success";
    label = fmtRemaining(remaining);
    tip = `Janela de 24h aberta — pode responder livremente. Fecha em ${fmtRemaining(remaining)}.`;
  }

  return (
    <Tooltip title={tip} arrow placement="bottom">
      <Chip
        icon={<AccessTimeIcon sx={{ fontSize: "0.7rem !important" }} />}
        label={label}
        size="small"
        color={color}
        sx={{
          height: 14,
          fontSize: "0.6em",
          fontWeight: "bold",
          borderRadius: 1,
          marginRight: "3px",
          "& .MuiChip-label": { paddingLeft: "4px", paddingRight: "5px" },
          "& .MuiChip-icon": { marginLeft: "3px", marginRight: "-4px" },
        }}
      />
    </Tooltip>
  );
};

export default WabaWindowChip;
